import { render, staticRenderFns } from "./SortOrderSelector.vue?vue&type=template&id=6634f998"
import script from "./SortOrderSelector.vue?vue&type=script&lang=ts"
export * from "./SortOrderSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports